/**
 * Product Bundle JS — Handles pin hover/click, checkbox toggle, price recalculation
 */
(function () {
  'use strict';

  function qs(sel, ctx) { return (ctx || document).querySelector(sel); }
  function qsa(sel, ctx) { return (ctx || document).querySelectorAll(sel); }
  function formatMoney(cents) {
    return window.AykahFormatMoney ? window.AykahFormatMoney(cents) : '$' + (cents / 100).toFixed(2);
  }
  function formatMoneyShort(cents) {
    return window.AykahFormatMoneyShort ? window.AykahFormatMoneyShort(cents) : '$' + Math.round(cents / 100);
  }

  var section = qs('[data-bundle-section]');
  if (!section) return;

  var jsonEl = qs('[data-bundle-json]', section);
  if (!jsonEl) return;

  var config;
  try { config = JSON.parse(jsonEl.textContent); } catch (e) { return; }

  // Track selected items
  var selected = {};
  config.products.forEach(function (p) { selected[p.id] = true; });

  /* ── COLOUR-AWARE COMPANIONS ──
     Every curated companion is rendered once, tagged with the viewed product's
     colours it belongs to, and shown or hidden here against the selected one.
     Same approach as the PDP gallery rather than a second mechanism doing the
     same job, and it keeps the rows server-rendered so the section still reads
     correctly with no JS.

     '*' means every colour, which is also what an automatically picked or
     legacy companion carries, so those never filter. */
  var currentColor = null;

  function colorMatches(colorsAttr, chosen) {
    if (!colorsAttr || colorsAttr === '*') return true;
    var list = String(colorsAttr).split('|');
    var wanted = chosen ? String(chosen).trim().toLowerCase() : null;
    for (var i = 0; i < list.length; i++) {
      var token = list[i].trim();
      if (token === '*') return true;
      if (wanted && token.toLowerCase() === wanted) return true;
    }
    return false;
  }

  function isVisible(p) { return colorMatches(p.colors, currentColor); }

  /* Inline style, not the hidden attribute or a class swap: the rows are
     display:flex and the thumbnails display:block from Tailwind, and a class
     beats [hidden] in the cascade, so hiding them any other way silently does
     nothing. */
  function setShown(el, shown) {
    if (el) el.style.display = shown ? '' : 'none';
  }

  function applyColorFilter() {
    config.products.forEach(function (p) {
      var shown = isVisible(p);
      setShown(qs('[data-bundle-item="' + p.id + '"]', section), shown);
      setShown(qs('[data-bundle-item-mobile="' + p.id + '"]', section), shown);
      setShown(qs('[data-bundle-thumb="' + p.id + '"]', section), shown);
      setShown(qs('[data-bundle-plus="' + p.id + '"]', section), shown);
    });
  }

  /* The viewed product's own row. Its variant is baked in by Liquid at page
     load and the picker never reloads the page, so without this the bundle kept
     posting whichever variant rendered first: pick Toffee Cream on the Lunel
     bed and Add Selected to Cart still added Cream Marshmallow. */
  function applySelectedVariant(detail) {
    if (!detail) return;
    var self = null;
    config.products.forEach(function (p) { if (p.id === 'self') self = p; });
    if (self) {
      if (detail.variantId) self.variant_id = detail.variantId;
      if (typeof detail.price === 'number') self.price = detail.price;
    }

    var priceEl = qs('[data-bundle-price="self"]', section);
    if (priceEl && typeof detail.price === 'number') {
      priceEl.textContent = formatMoney(detail.price);
    }

    var labelEl = qs('[data-bundle-variant-label="self"]', section);
    if (labelEl && detail.title && detail.title !== 'Default Title') {
      labelEl.textContent = detail.title;
    }

    var thumbImg = qs('[data-bundle-thumb-img="self"]', section);
    if (thumbImg && detail.featuredImage) {
      thumbImg.src = detail.featuredImage;
    }

    currentColor = detail.color || null;
    applyColorFilter();
    updateUI();
  }

  document.addEventListener('product:variant-change', function (e) {
    applySelectedVariant(e.detail);
  });

  // ── PIN INTERACTIONS ──
  function showCard(id) {
    var card = qs('[data-pin-card="' + id + '"]', section);
    var dot = qs('[data-pin-trigger="' + id + '"] [data-pin-dot]', section);
    if (card) card.classList.remove('hidden');
    if (card) card.classList.add('lg:block');
    if (dot) {
      dot.classList.remove('bg-white', 'scale-100');
      dot.classList.add('bg-accent', 'scale-125', 'shadow-accent/40');
    }
  }

  function hideCard(id) {
    var card = qs('[data-pin-card="' + id + '"]', section);
    var dot = qs('[data-pin-trigger="' + id + '"] [data-pin-dot]', section);
    if (card) { card.classList.add('hidden'); card.classList.remove('lg:block'); }
    if (dot) {
      dot.classList.add('bg-white', 'scale-100');
      dot.classList.remove('bg-accent', 'scale-125', 'shadow-accent/40');
    }
  }

  var activePin = null;

  // Pin trigger click/hover
  qsa('[data-pin-trigger]', section).forEach(function (btn) {
    var id = btn.dataset.pinTrigger;
    btn.addEventListener('click', function () {
      if (activePin === id) {
        hideCard(id);
        activePin = null;
      } else {
        if (activePin) hideCard(activePin);
        showCard(id);
        activePin = id;
      }
    });
    btn.addEventListener('mouseenter', function () {
      if (activePin && activePin !== id) hideCard(activePin);
      showCard(id);
      activePin = id;
    });
  });

  // Pin card hover (keep visible)
  qsa('[data-pin-card]', section).forEach(function (card) {
    card.addEventListener('mouseenter', function () {
      // Keep card visible
    });
    card.addEventListener('mouseleave', function () {
      var id = card.dataset.pinCard;
      hideCard(id);
      activePin = null;
    });
  });

  // Pin close buttons
  qsa('[data-pin-close]', section).forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.stopPropagation();
      var id = btn.dataset.pinClose;
      hideCard(id);
      activePin = null;
    });
  });

  // ── TOGGLE BUNDLE SELECTION ──
  function toggleItem(id) {
    selected[id] = !selected[id];
    updateUI();
  }

  // Bundle toggle from pin card
  qsa('[data-bundle-toggle]', section).forEach(function (btn) {
    btn.addEventListener('click', function () {
      toggleItem(btn.dataset.bundleToggle);
    });
  });

  // Desktop strip items
  qsa('[data-bundle-item]', section).forEach(function (item) {
    item.addEventListener('click', function () {
      toggleItem(item.dataset.bundleItem);
    });
    item.addEventListener('mouseenter', function () {
      var id = item.dataset.bundleItem;
      if (activePin && activePin !== id) hideCard(activePin);
      showCard(id);
      activePin = id;
    });
    item.addEventListener('mouseleave', function () {
      var id = item.dataset.bundleItem;
      hideCard(id);
      activePin = null;
    });
  });

  // Mobile items
  qsa('[data-bundle-item-mobile]', section).forEach(function (item) {
    item.addEventListener('click', function () {
      toggleItem(item.dataset.bundleItemMobile);
    });
  });

  // ── UPDATE UI ──
  function updateUI() {
    var selectedCount = 0;
    var total = 0;

    /* Hidden rows keep their ticked state but stay out of the total, so
       switching colour and back restores what the shopper had. */
    config.products.forEach(function (p) {
      if (selected[p.id] && isVisible(p)) {
        selectedCount++;
        total += p.price;
      }
    });

    // No savings figure is computed or shown.
    //
    // The bundle gives no discount of its own, so the only "saving" available
    // was the sum of markdowns the items already carry on their own. Printing
    // that under a bundle CTA reads as "you save by buying the set", when the
    // shopper pays the same buying them separately. The page cannot honour that
    // claim, so it does not make it. Item-level sale pricing still appears where
    // it is true, on each product's own page and card.
    //
    // If a genuine bundle discount is introduced later, it should come from a
    // Shopify automatic discount so the cart enforces it, rather than a number
    // this script invents and hopes checkout agrees with.
    var totalEl = qs('[data-bundle-total]', section);
    if (totalEl) totalEl.textContent = formatMoney(total);

    // Update mobile total. Same rule as desktop: total only, and the
    // strikethrough/savings elements are hidden if a stale template still
    // renders them.
    var totalMobile = qs('[data-bundle-total-mobile]', section);
    var origMobile = qs('[data-bundle-original-mobile]', section);
    var saveMobile = qs('[data-bundle-savings-mobile]', section);

    if (totalMobile) totalMobile.textContent = formatMoney(total);
    if (origMobile) origMobile.classList.add('hidden');
    if (saveMobile) saveMobile.classList.add('hidden');

    // Update checkboxes — desktop
    config.products.forEach(function (p) {
      var cb = qs('[data-bundle-checkbox="' + p.id + '"]', section);
      var item = qs('[data-bundle-item="' + p.id + '"]', section);
      if (cb) {
        if (selected[p.id]) {
          cb.classList.remove('border-border');
          cb.classList.add('bg-foreground', 'border-foreground');
          cb.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" class="w-2.5 h-2.5 text-white" viewBox="0 0 256 256" fill="currentColor"><path d="M229.66,77.66l-128,128a8,8,0,0,1-11.32,0l-56-56a8,8,0,0,1,11.32-11.32L96,188.69,218.34,66.34a8,8,0,0,1,11.32,11.32Z"/></svg>';
        } else {
          cb.classList.add('border-border');
          cb.classList.remove('bg-foreground', 'border-foreground');
          cb.innerHTML = '';
        }
      }
      if (item) {
        if (selected[p.id]) {
          item.classList.add('is-selected');
        } else {
          item.classList.remove('is-selected');
        }
      }

      // Mobile checkbox
      var cbm = qs('[data-bundle-checkbox-mobile="' + p.id + '"]', section);
      var itemm = qs('[data-bundle-item-mobile="' + p.id + '"]', section);
      if (cbm) {
        if (selected[p.id]) {
          cbm.classList.remove('border-border');
          cbm.classList.add('bg-foreground', 'border-foreground');
          cbm.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" class="w-2.5 h-2.5 text-white" viewBox="0 0 256 256" fill="currentColor"><path d="M229.66,77.66l-128,128a8,8,0,0,1-11.32,0l-56-56a8,8,0,0,1,11.32-11.32L96,188.69,218.34,66.34a8,8,0,0,1,11.32,11.32Z"/></svg>';
        } else {
          cbm.classList.add('border-border');
          cbm.classList.remove('bg-foreground', 'border-foreground');
          cbm.innerHTML = '';
        }
      }
      if (itemm) {
        if (selected[p.id]) {
          itemm.classList.add('is-selected');
        } else {
          itemm.classList.remove('is-selected');
        }
      }

      // Dim deselected thumbnails (frequently-bought-together layout)
      var thumb = qs('[data-bundle-thumb="' + p.id + '"]', section);
      if (thumb) thumb.style.opacity = selected[p.id] ? '1' : '0.35';

      // Update pin card toggle buttons
      var toggle = qs('[data-bundle-toggle="' + p.id + '"]', section);
      if (toggle) {
        if (selected[p.id]) {
          toggle.textContent = 'Selected';
          toggle.className = 'w-full mt-2.5 py-2 rounded-lg text-[10px] font-semibold uppercase tracking-wider transition-colors bg-accent/10 text-accent';
        } else {
          toggle.textContent = 'Add to Bundle';
          toggle.className = 'w-full mt-2.5 py-2 rounded-lg text-[10px] font-semibold uppercase tracking-wider transition-colors bg-secondary text-foreground';
        }
      }
    });
  }

  // ── ADD BUNDLE TO CART ──
  function addBundleToCart() {
    var items = [];
    config.products.forEach(function (p) {
      if (selected[p.id] && p.variant_id && isVisible(p)) {
        items.push({ id: p.variant_id, quantity: 1 });
      }
    });

    if (items.length === 0) return;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items }),
      credentials: 'same-origin'
    })
      .then(function (res) {
        if (!res.ok) throw new Error('Failed');
        return res.json();
      })
      .then(function () {
        document.dispatchEvent(new CustomEvent('cart:updated'));
        document.dispatchEvent(new CustomEvent('cart:open'));
      })
      .catch(function () {
        /* silent — cart error handled gracefully */
      });
  }

  var addAllBtn = qs('[data-bundle-add-all]', section);
  var addAllMobileBtn = qs('[data-bundle-add-all-mobile]', section);
  if (addAllBtn) addAllBtn.addEventListener('click', addBundleToCart);
  if (addAllMobileBtn) addAllMobileBtn.addEventListener('click', addBundleToCart);

  /* Initial state. The opening variant is published by product-page.js on
     DOMContentLoaded, which is after this deferred script has bound its
     listener, so the filter lands before first paint in the normal case.

     The stash covers a late bind, such as the theme editor re-rendering this
     section after init has already run. With neither, nothing is filtered and
     the server-rendered rows stand: failing open shows companions for the wrong
     colour, failing closed would empty the section entirely. */
  if (window.AykahSelectedVariant) {
    applySelectedVariant(window.AykahSelectedVariant);
  } else {
    updateUI();
  }
})();
